import { Controller } from "@hotwired/stimulus";

// business-services--learning-projects--funding-provider
export default class extends Controller {
  static targets = ["registrationFolderTemplate",
                    "registrationFoldersContainer",
                    "searchByIdContainer",
                    "searchByIdInput",
                    "learningProjectContainer",
                    "loaderContainer"];

  static values = {
    fundingType: { type: String },
    searchByContactUrl: { type: String },
    fetchRegistrationFolderUrl: { type: String },
    waitSeconds: { type: Number, default: 1 },
    lastnameSelector: { type: String, default: ".lastname" },
    firstnameSelector: { type: String, default: ".firstname" },
    lastUpdateSelector: { type: String, default: ".last-update" },
    emailSelector: { type: String, default: ".email" },
    phoneSelector: { type: String, default: ".phone" },
    mobilePhoneSelector: { type: String, default: ".mobile" },
    addressSelector: { type: String, default: ".address" },
    externalIdSelector: { type: String, default: ".external-id" },
    amountUntaxedSelector: { type: String, default: ".amount-untaxed" },
    amountTaxedSelector: { type: String, default: ".amount-taxed" },
    trainingStartDateSelector: { type: String, default: ".training-start-date" },
    trainingEndDateSelector: { type: String, default: ".training-end-date" },
    trainingTitleSelector: { type: String, default: ".training-title" },
    externalIdInputSelector: { type: String, default: "input[name*='external_id']"}
  }

  initialize() {
    if(this.fundingTypeValue != "individual") {
      this.updateSubmitButton();
      this.searchByContact();
    }
  }

  showLoader() {
    $("div", $(this.loaderContainerTarget)).show();
  }

  hideLoader() {
    $("div", $(this.loaderContainerTarget)).hide();
  }

  updateSubmitButton() {
    if($(this.externalIdInputSelectorValue).val() != undefined) {
      $('[type="submit"]').prop('disabled', false);
    } else {
      $('[type="submit"]').prop('disabled', true);
    }
  }

  onSearchById(event) {
    event.preventDefault();

    this.searchById($(this.searchByIdInputTarget).val());
  }

  searchById(externalId) {
    let controller = this;

    if(!externalId) { return; }

    this.showLoader();

    $.get(this.fetchRegistrationFolderUrlValue.replace(/ID/g, externalId), function(data) {
      if(data.registration_folder) {
        controller.displayRegistrationFolders([data.registration_folder]);
      } else {
        controller.registrationFolderNotFound();
      }
    }).fail(function() {
      controller.waitAndRetry();
    }).always(function() {
      controller.updateSubmitButton();
      controller.hideLoader();
    });
  }

  searchByContact() {
    let controller = this;

    this.showLoader();

    $.get(this.searchByContactUrlValue, function(data) {
      if(!data.success) {
        alert("L'API Wedof semble avoir des problèmes. Veuillez réessayer ultérieurement");
      }

      if(data.registration_folders.length == 0) {
        controller.askForAdministrativeId();
      } else {
        controller.displayRegistrationFolders(data.registration_folders);
      }

      controller.hideLoader();
    }).fail(function() {
      controller.waitAndRetry();
      controller.hideLoader();
    }).always(function() {
      controller.updateSubmitButton();
    });
  }

  registrationFolderNotFound() {
    this.registrationFoldersContainerTarget.innerHTML = "";
    this.registrationFoldersContainerTarget.insertAdjacentHTML('beforeend', "<span class='text-danger'>Dossier introuvable</span>");
  }

  waitAndRetry() {
    this.waitSecondsValue *= 2;

    if(this.waitSecondsValue < 20) {
      setTimeout(this.searchByContact.bind(this), this.waitSecondsValue * 1000);
    } else {
      this.hideLoader();
      this.askForAdministrativeId();
    }
  }

  askForAdministrativeId() {
    $(this.searchByIdContainerTarget).removeClass("hide");
    $('input[type=text]', this.searchByIdContainerTarget).focus();
  }

  fillField($selector, value, isDate) {
    if(!value) {
      return;
    }

    if (isDate) {
      $selector.html(value.split('T')[0]);
    } else {
      $selector.html(value);
    }

    $selector.parent().removeClass("hide");
  }

  fillTemplateInput($content, externalId, checked) {
    let $input = $(this.externalIdInputSelectorValue, $content);
    let $label = $("label", $content);

    $input.attr("id", $input.attr("id").replace("value", externalId));
    $label.attr("for", $label.attr("for").replace("VALUE", externalId));
    $input.val(externalId);

    if(checked) {
      $input.attr('checked', 'checked').trigger('click');
    }
  }

  displayRegistrationFolders(registrationFolders) {
    let controller = this;

    controller.registrationFoldersContainerTarget.innerHTML = "";

    $.each(registrationFolders, function(index, registrationFolder) {
      let $content = $(controller.registrationFolderTemplateTarget.innerHTML);
      let externalId = registrationFolder.externalId;

      controller.fillTemplateInput($content, externalId, index == 0);

      controller.fillField($(controller.externalIdSelectorValue, $content), externalId, false);
      controller.fillField($(controller.lastUpdateSelectorValue, $content), registrationFolder.lastUpdate, true);
      controller.fillField($(controller.lastnameSelectorValue, $content), registrationFolder.attendee.lastName, false);
      controller.fillField($(controller.firstnameSelectorValue, $content), registrationFolder.attendee.firstName, false);
      controller.fillField($(controller.emailSelectorValue, $content), registrationFolder.attendee.email, false);
      controller.fillField($(controller.phoneSelectorValue, $content), registrationFolder.attendee.phoneFixed, false);
      controller.fillField($(controller.mobilePhoneSelectorValue, $content), registrationFolder.attendee.phoneNumber, false);
      controller.fillField($(controller.addressSelectorValue, $content), registrationFolder.attendee.fullAddress, false);
      controller.fillField($(controller.amountUntaxedSelectorValue, $content), registrationFolder.trainingActionInfo.totalExcl, false);
      controller.fillField($(controller.amountTaxedSelectorValue, $content), registrationFolder.trainingActionInfo.totalIncl, false);
      controller.fillField($(controller.trainingTitleSelectorValue, $content), registrationFolder.trainingActionInfo.title, false);
      controller.fillField($(controller.trainingStartDateSelectorValue, $content), registrationFolder.trainingActionInfo.sessionStartDate, true);
      controller.fillField($(controller.trainingEndDateSelectorValue, $content), registrationFolder.trainingActionInfo.sessionEndDate, true);

      controller.registrationFoldersContainerTarget.insertAdjacentHTML('beforeend', $content[0].innerHTML);
    });
  }
}
